"use strict";

module.exports = {
  PHONE_SMALL: 370,
  PHONE_GIANT: 541,
  PHONE: 599,
  MEDIUM_TABLETS: 600,
  TABLETS: 600,
  MOBILE: 1023,
  DESKTOP: 1024,
  // DESKTOP S
  DESKTOP_SMALL: 1024,
  // DESKTOP S
  DESKTOP_MEDIUM: 1360,
  // DESKTOP M
  DESKTOP_LARGE_BOARD: 1600,
  // DESKTOP L
  DESKTOP_LARGE: 1600,
  // DESKTOP L
  DESKTOP_EXTRA_LARGE: 1716,
  TABLET_S: 600,
  TABLET_L: 768,
  DESKTOP_S: 1024,
  /**
   * Брейкпоинт на замену DESKTOP_M
   * Так как требуется плавный переход на платформе, старое значение также сохраняем
   */
  DESKTOP_MD: 1280,
  DESKTOP_M: 1360,
  DESKTOP_L: 1600
};